<kendo-dialog *ngIf="Data.alertVisible=='success'" (close)="closePopup()"  [width]="Width"
    class="custom-dialog  ">
    <div class="row col-12 dialog-content ">
        <div class="arrow-svg colpadding0">
            <div class="col-12 image colpadding0">
                <img class="alertTick" src="../assets/vectors/alertTick.svg">
            </div>
            <div class="col-12 image colpadding0">
                <img class="alertHurry" src="../assets/vectors/alertHurry.svg">
            </div>
        </div>
        <div class="col-md-12 f-label alert-msg">
            <h4 class="f-label" >{{Data.alertMessage}}</h4>
        </div>
    </div>
    <kendo-dialog-actions style="border: none; margin-bottom: 10px;">
        <div class="col-md-12 ok-btn colpadding0">
            <button title="OK" (click)="closePopup()" class="figma-btn-green"><span>OK</span></button>
        </div>
    </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog *ngIf="Data.alertVisible=='error'" [width]="Width" 
    class="custom-dialog  ">
    <div class="row col-12 dialog-content ">
        <div class="arrow-svg colpadding0">
            <div class="col-12 image colpadding0" >
                <img clas="alertCross" src="../assets/vectors/alertCross.svg"
                    >
            </div>
            <div class="col-12 image colpadding0">
                <img class="alertOps" src="../assets/vectors/alertOps.svg">
            </div>
        </div>
        <div class="col-md-12 f-label alert-msg" >
            <h4 class="f-label">{{Data.alertMessage}}</h4>
        </div>
    </div>
    <kendo-dialog-actions style="border: none; margin-bottom: 10px;">
        <div class="col-md-12 f-label ok-btn colpadding0">
            <button title="OK" kendoButton (click)="closePopup()" class="figma-btn-green"
                style="background-color: #F34C4D;"><span>OK</span></button>
        </div>
    </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog *ngIf="Data.alertVisible=='InvalidFile'" [width]="Width" 
    class="custom-dialog  ">
    <div class="row col-12 dialog-content ">
        <div class="arrow-svg colpadding0">
            <div class="col-12 image colpadding0" >
                <img clas="alertCross" style="height: 58px; padding: 0px 0px 10px 10px;" src="../assets/vectors/Invalid_Format_Icon.svg">
            </div>
            <div class="col-12 image colpadding0">
                <img class="alertOps" src="../assets/vectors/alertOps.svg">
            </div>
        </div>
        <div class="col-md-12 f-label alert-msg" >
            <h4 class="f-label">{{Data.alertMessage}}</h4>
        </div>
    </div>
    <kendo-dialog-actions style="border: none; margin-bottom: 10px;">
        <div class="col-md-12 f-label ok-btn colpadding0">
            <button title="OK" kendoButton (click)="closePopup()" class="figma-btn-green"
                style="background-color: #F34C4D;"><span>OK</span></button>
        </div>
    </kendo-dialog-actions>
</kendo-dialog>


<kendo-dialog *ngIf="Data.alertVisible=='confirm'" [width]="Width" 
    class="custom-dialog  ">
    <div class="row col-12 dialog-content ">
        <div class="arrow-svg colpadding0">
            <div class="col-12 image colpadding0" >
               <label  style="color: black; font-weight: 600; margin-top: 1.8rem; font-size: 18px; ">Confirmation!</label>
            </div>
        </div>  
        <div class="col-md-12 f-label alert-msg" style="margin-top:10px">
            <h4 class="f-label" >{{Data.alertMessage}}</h4>
        </div>
    </div>
    <kendo-dialog-actions style="border: none; margin-bottom: 10px;"> 
        <div class="col-md-12  ok-btn-confirm colpadding0">
            <button title="Cancel"  (click)="closePopup()" class="figma-btn-gray " ><span>Cancel</span></button>
            <button title="OK" (click)="onConfirm()" class="figma-btn-blue" ><span>OK</span></button>
        </div>
    </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog *ngIf="Data.alertVisible =='info'" [width]="Width" class="custom-dialog  ">
    <div class="row col-12 dialog-content ">
        <!-- <div class="arrow-svg">
            <div class="col-12" >
               <label  style="color: black; font-weight: 600; margin-top: 2rem; font-size: 18px; margin-left: -20px;">Confirmation!</label>
            </div>
        </div> -->
        <div class="col-md-12 f-label alert-msg colpadding0" style="margin-top: 2rem;">
            <h4 class="f-label " >{{Data.alertMessage}}</h4>
        </div>
    </div>

    <kendo-dialog-actions style="border: none; margin-bottom: 10px;">
        <div class="col-md-12 f-label ok-btn colpadding0">
            <button title="OK" kendoButton (click)="closePopup()" class="figma-btn-green"
                style="background-color: #125AAB;"><span>OK</span></button>
        </div>
    </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog
  *ngIf="Data.alertVisible === 'warning'"
  [width]="Width"
  class="custom-dialog"
  
>
  <div class="dialog-body text-center">
    <!-- Red X Icon -->
    <div class="icon-wrapper">
      <span class="close-icon">✕</span>
    </div>

    <!-- Title -->
    <h3 class="dialog-title">Deactivate</h3>

    <!-- Message -->
    <p class="dialog-message">
      Are You Sure To Deactivate Director
    </p>
  </div>

  <!-- Actions -->
    <kendo-dialog-actions style="border: none; margin-bottom: 10px;"> 
        <div class="col-md-12  ok-btn-confirm colpadding0">
            <button title="No"  (click)="closePopup()" class="figma-btn-gray " ><span>No</span></button>
            <button title="Yes" (click)="onConfirmDisable();" class="figma-btn-blue" ><span>Yes</span></button>
        </div>
    </kendo-dialog-actions>
</kendo-dialog>


<kendo-dialog
  *ngIf="Data.alertVisible === 'replacement'"
  [width]="Width"
  class="custom-dialog"
>
  <div class="popup-body">
    <p class="popup-title">
      If there is any replacement
    </p>

    <div class="radio-group">
      <label class="radio-option">
        <input
          type="radio"
          name="replacement"
          value="yes"
          [(ngModel)]="replacementValue"
        />
        <span>Yes</span>
      </label>

      <label class="radio-option">
        <input
          type="radio"
          name="replacement"
          value="no"
          [(ngModel)]="replacementValue"
        />
        <span>No</span>
      </label>
    </div>
  </div>

  <!-- <kendo-dialog-actions class="popup-actions">
    <button kendoButton (click)="closePopup()">Close</button>
  </kendo-dialog-actions> -->
</kendo-dialog>
